import Gallery from "./Gallery";

const WireNameGallery = () => {
  const wirenames = [
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/anthony.jpg",
      alt: "The name 'Anthony' written in gold wire, resting on a light gray background.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/bubbles.jpg",
      alt: "The name 'Bubbles' written in silver wire, resting on a black background with a roll of wire and pair of pliers.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/shadow.jpg",
      alt: "The name 'Shadow' written in silver wire, held up by pliers pinching the bottom of the 'S' over a dark background.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/aiden.jpg",
      alt: "The name 'Aiden' written in gold wire, held up by pliers pinching the bottom of the 'n' over a dark background.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/akshay.jpg",
      alt: "The name 'Akshay' written in gold wire, held up by pliers pinching the bottom of the 'A' over a dark background.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/alex.jpg",
      alt: "alex",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/avery.jpg",
      alt: "avery",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/danny.jpg",
      alt: "danny",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/dylan.jpg",
      alt: "dylan",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/elise.jpg",
      alt: "elise",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/emma.jpg",
      alt: "emma",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/gwen.jpg",
      alt: "gwen",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/irene.jpg",
      alt: "irene",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/jayden.jpg",
      alt: "jayden",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/jennifer.jpg",
      alt: "jennifer",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/lexie.jpg",
      alt: "lexie",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/little_b.jpg",
      alt: "little_b",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/toph.jpg",
      alt: "toph",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/oliver.jpg",
      alt: "The name Oliver made out of wire.",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/penny.jpg",
      alt: "penny",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/rebecca.jpg",
      alt: "rebecca",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/sarah.jpg",
      alt: "sarah",
    },

    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/therese.jpg",
      alt: "therese",
    },
    {
      src: "https://storage.googleapis.com/squidslippers-media/art/wire_names/zachary.jpg",
      alt: "zachary",
    },
  ];

  return <Gallery pictures={wirenames} />;
};

export default WireNameGallery;
